import { useEffect } from 'react';
import { prefetchFormToken } from './formToken';
import { HONEYPOT_FIELD } from './spamGuard.constants';

// Off-screen + aria-hidden + not tabbable, so real users never see or fill these.
const hiddenStyle: React.CSSProperties = {
  position: 'absolute',
  left: '-9999px',
  top: 'auto',
  width: '1px',
  height: '1px',
  overflow: 'hidden',
};

type SpamGuardFieldsProps = {
  // register comes from many differently-typed forms (some typed as a bare
  // Function), so keep it permissive.
  register: any;
};

/**
 * Honeypot field plus a background fetch of the signed form token. Drop inside
 * any form's <form> element; the submit helpers attach the token, and the form
 * APIs enforce both (see helpers/forms/spamGuard.server).
 */
export const SpamGuardFields = ({ register }: SpamGuardFieldsProps) => {
  useEffect(() => {
    prefetchFormToken();
  }, []);

  return (
    <div aria-hidden="true" style={hiddenStyle}>
      <label htmlFor={HONEYPOT_FIELD}>Bitte dieses Feld leer lassen</label>
      <input
        id={HONEYPOT_FIELD}
        type="text"
        tabIndex={-1}
        autoComplete="off"
        {...register(HONEYPOT_FIELD)}
      />
    </div>
  );
};

export default SpamGuardFields;
